<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  mounted () {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Some data',
          borderColor: '#FF6A64',
          backgroundColor: '#FF6A64',
          fill: false,
          data: [3, 6, 3, 5, 2, 3]
        }
      ]
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/advertiser/plugins/chart.vue